export default {"src":"/_next/static/media/discountGreen_24.b48192a6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};